import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationWithIdInput } from '../../../../types/schema/utils.types';
import { Transaction } from '../../../../types/schema/transaction.types';

interface GetAllTransactionsByUserIdByPageHook {
  data: Transaction[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllTransactionsByUserIdByPage: Transaction[];
    }>
  >;
}

interface UseGetAllTransactionsByUserIdByPageMutationData {
  getAllTransactionsByUserIdByPage: Transaction[];
}

interface UseGetAllTransactionsByUserIdByPageInputType {
  input: PaginationWithIdInput;
}

export function useGetAllTransactionsByUserIdByPage(
  query: DocumentNode,
  input: PaginationWithIdInput
): GetAllTransactionsByUserIdByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    UseGetAllTransactionsByUserIdByPageMutationData,
    UseGetAllTransactionsByUserIdByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllTransactionsByUserIdByPage,
    loading,
    error,
    refetch,
  };
}
